import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Component({
	selector: 'dev-screen',
	templateUrl: './dev-screen.component.html',
	styleUrls: ['./dev-screen.component.scss']
})

export class DevScreenComponent implements OnInit, OnDestroy {
	@ViewChild('formRef') form: NgForm;
	data: any = {
		adunitPlayoutId: 'new_default',
		mediaclipId: '1089422'
	};

	subscriptions: Subscription;

	constructor(
		protected route: ActivatedRoute,
		protected location: Location,
		protected http: HttpClient
	) {
		this.subscriptions = new Subscription();
	}

	ngOnInit() { }

	ngOnDestroy() {
		if (this.subscriptions) {
			this.subscriptions.unsubscribe();
		}
	}
}
